export const missionDiaryConstant = {
    GET_IS_ENABLED: 'GET_IS_ENABLED',
    GET_IS_MANUAL_SEQUENCE_ENABLED: 'GET_IS_MANUAL_SEQUENCE_ENABLED',
    GET_RECORDS: 'GET_RECORDS',
    GET_UPDATED_DATETIME: 'GET_UPDATED_DATETIME',
    CHECK_DAILY_CHECKIN_IS_ENABLED: 'CHECK_DAILY_CHECKIN_IS_ENABLED',
    GET_MEMBER_MISSION_STATUS: 'GET_MEMBER_MISSION_STATUS',
    GET_MEMBER_MISSION_RECORD: 'GET_MEMBER_MISSION_RECORD',
    CLOSE_DAILY_CHECKIN_POPUP: 'CLOSE_DAILY_CHECKIN_POPUP',
};
